import { AccessorsMutatorsDecorator } from '../../helpers';
import {
    TranslatableModel
} from './translatable-model';
import moment from 'moment';

export class ReservationAccommodation extends TranslatableModel {


    static get translatableAttributes() {

        return ['type.description'];
    }

    get defTimeFormat() {

        return 'YYYY-MM-DD';
    }

    get numberOfNights() {

        const nights = moment(this.departure, this.defTimeFormat).diff(moment(this.arrival, this.defTimeFormat), 'days');
        return nights === 0 ? 1 : nights;
    }

    static performOverride(accommodation, diffInDays) {

        return (pricing, index) => {

            const prices = Object.entries(pricing.prices)
                .reduce((prices, [date, price]) => {

                    const adjustedDate = moment(date).add(diffInDays, 'days').format('YYYY-MM-DD');

                    prices[adjustedDate] = price;

                    return prices;
                }, {});

            return Object.assign(accommodation.pricing[index], {
                prices: prices,
                total: pricing.total,
            });
        };
    }

    setRate(rate) {

        if (!this.type) return;

        if (Object.keys(this.type).length && rate) {

            this['rate_type'] = angular.isDefined(rate['derived']) ? (rate['promotion_code'] ? 'promo' : 'plan') : 'base';

        }

        return rate;
    }

    calculateTotal(datesArray, availability, usePricing = true) {

        let total = 0;


        if (this.pricing.length && usePricing) {

            total += this.pricing.reduce((summary, pricingObj) => {

                for (let date of datesArray) {

                    let priceInDay = parseFloat(pricingObj.prices[date.format(this.defTimeFormat)]);

                    if (!isNaN(priceInDay)) {

                        summary += priceInDay;

                    } else {

                        let datesCopy = datesArray.slice(datesArray.indexOf(date));

                        summary += this.totalOnRate(datesCopy, availability);

                        break;
                    }
                }

                return summary;
            }, 0);

        }

        let lastRatesLength = usePricing ? this.quantity - this.pricing.length : this.quantity;

        if (lastRatesLength > 0) {

            total += lastRatesLength * this.totalOnRate(datesArray, availability);

        }

        return total;
    }

    totalOnRate(datesRange, availability) {

        let total = 0;

        const periodLength = datesRange.length - 1;

        for (let i = 0; i <= periodLength; i++) {

            total += parseFloat(availability[datesRange[i].format(this.defTimeFormat)].price);
        }

        return total;
    }

    createPricesArray(datesRange, availability, room = {
        id: null
    }, priceList = null) {

        let pricePerRoom = priceList ||  {
            prices: {},
            accommodation_id: this.id || null,
        };

        pricePerRoom['total'] = 0;

        pricePerRoom['room_id'] = room.id;

        for(let date of datesRange) {

            const dateKey = date.format(this.defTimeFormat);

            let currentPrice =  pricePerRoom.prices[dateKey];

            const priceInDay = !angular.isUndefined(currentPrice) ?  parseFloat(currentPrice) : parseFloat(availability[dateKey].price);

            pricePerRoom.prices[dateKey] = priceInDay;

            pricePerRoom.total += priceInDay;

        }

        return pricePerRoom;
    }


    realcBaseRatesOnPerPersonPricing(basePricing, rateType) {

        let additionalAdults = rateType.adults_included_in_rate - this.adults_quantity < 0 ?
            -1 * (rateType.adults_included_in_rate - this.adults_quantity) : 0;

        let additionalChildren = rateType.children_included_in_rate - this.children_quantity < 0 ?
            -1 * (rateType.children_included_in_rate - this.children_quantity) : 0;

        if ((additionalAdults > 0 || additionalChildren > 0) && rateType.additional_charge) {

            for (let day in basePricing) {

                let additionalPricesForAdults = basePricing[day].adult.slice(0, additionalAdults);

                let additionalPricesForChildren = basePricing[day].child.slice(0, additionalChildren);

                const childrenPrice = additionalPricesForAdults.reduce((acc, cur) => acc + parseFloat(cur), 0);

                const adultsPrice = additionalPricesForChildren.reduce((acc, cur) => acc + parseFloat(cur), 0);

                basePricing[day] = parseFloat(basePricing[day]) + childrenPrice + adultsPrice;
            }
        }

        return basePricing;

    }

    generateDatesArray(){

        let datesArray = [];

        let iterDate = moment(this.arrival, this.defTimeFormat);

        let daysQuantity = moment(this.departure, this.defTimeFormat).diff(iterDate, 'days');
        
        for (let inc = 0; inc <= daysQuantity; inc++) {

            datesArray.push(iterDate.clone().add(inc, 'days'));
        }

        return datesArray;
    }

    getDepartureDate() {

        if (this.same_day_checkout) {

            return moment(this.departure).subtract(1, 'day').format('YYYY-MM-DD');
        }

        return this.departure;
    }
}

AccessorsMutatorsDecorator('id', ...ReservationAccommodation.translatableAttributesWithLanguageAliases, 'reservation', 'type', 'room',
    'rooms', 'arrival', 'departure', 'reservation_ident', 'quantity',
    'changedFrom', 'total', 'adults_quantity', 'children_quantity', 'rate', 'pricing',
    'accommodation_addons', 'rate_type', 'rate_package_id', 'type_id', 'guests', 'guest',
    'children', 'replace_primary', 'type_name', 'type_name_ar', 'ota_total_price', 'ignore_invoicing',
    'same_day_checkout', 'auto_extended_dates',
)(ReservationAccommodation);



// WEBPACK FOOTER //
// ./src/pms-api/models/reservation-accommodation.model.js